import {createReducer} from "redux-act";
import {toggleDropdownMenu, toggleMenu, toggleSubMenu} from "modules/actions";

interface IMenuReducer {
	isOpen: boolean;
	isDropdown: boolean;
	activeSubMenu: string | null;
}

const initial: IMenuReducer = {
	isOpen: false,
	isDropdown: false,
	activeSubMenu: null,
};

export const menu = createReducer({}, initial)
	.on(toggleMenu, (state, payload) => ({
		...state,
		isOpen: payload,
	}))
	.on(toggleDropdownMenu, (state, payload) => ({
		...state,
		isDropdown: payload,
	}))
	.on(toggleSubMenu, (state, payload) => ({
		...state,
		activeSubMenu: payload,
	}));
